import { render, staticRenderFns } from "./DowngradeSubscriptionModal.vue?vue&type=template&id=4d34e514"
import script from "./DowngradeSubscriptionModal.vue?vue&type=script&lang=js"
export * from "./DowngradeSubscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./DowngradeSubscriptionModal.vue?vue&type=style&index=0&id=4d34e514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports